import React from 'react'
import { CardContainer } from './style'

function ShimmerEffect({ width, height, radius,className }) {
  return (
   <CardContainer width={width} height={height} radius={radius} className={className}></CardContainer>
  )
}
export default ShimmerEffect
